import initiateInactivityTimer from './inactivityTimer';

const getSessionStorageField = (field, defaultValue) => {
  try {
    const ret = JSON.parse(sessionStorage.getItem(field));
    return ret ? ret : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const setSessionStorageField = (field, value) => {
  if (value === null) {
    return sessionStorage.removeItem(field);
  }
  return sessionStorage.setItem(field, JSON.stringify(value));
};

const samePass = (pass1, pass2) => {
  for (const [key, value] of Object.entries(pass1)) {
    if (key === 'quantity') continue;
    if (value !== pass2[key]) return false;
  }
  return true;
};

export {
  getSessionStorageField,
  setSessionStorageField,
  initiateInactivityTimer,
  samePass
};
